import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
const useStyles = makeStyles((theme) => ({
  formControl: {
    height:34,
    minWidth: "90%"
  },
  selectEmpty: {
    
  },
}));

const SelectInput = ({value, onChange, data = [], param="", valueKey, name}) => {
  const classes = useStyles();
  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        value={value}
        onChange={onChange}
        name={name}
        style={{height:34,fontSize:12}}
      >
        <MenuItem value="">
          <span style={{fontSize:12}}>None </span>
        </MenuItem>
        {data?.map((item,index) => <MenuItem style={{fontSize:12}} key={index} value={item[valueKey]}>{item[param]}</MenuItem>  )}
      </Select>
    </FormControl>
  );
};

export default SelectInput;
